import {inject, injectable} from "inversify";
import type {IHttpClientService} from "data/services/http";
import type {AxiosResponse} from "axios";
import {Bindings} from "data/constants/bindings";
import {TBrazeResponse} from "data/stores/braze/braze.store";

export interface IBrazeApiProvider {
	preferenceUrl: () => Promise<AxiosResponse<TBrazeResponse>>;
	startTracking: () => Promise<AxiosResponse>;
}

@injectable()
export class BrazeApiProvider implements IBrazeApiProvider {
	constructor(@inject(Bindings.ApiHTTPClient) private _http: IHttpClientService) {}

	preferenceUrl = () => this._http.get<TBrazeResponse>("braze/preference-center-url");
	startTracking = () => this._http.post("braze/track-user");
}
